import React from "react";
import {
  Button,
  Checkbox,
  IconButton,
  SearchField,
  SelectField,
} from "@tiny/components";

import Refresh from "@tiny/icons/generated/Refresh";
import AutoAwesome from "@tiny/icons/generated/AutoAwesome";
import { useTrafficShapingFilter } from "./TrafficShapingFilter.hooks";
import { useStyles } from "./TrafficShapingFilter.styles";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

function TrafficShapingFilter({
  onAITrafficShapingClick,
}: {
  onAITrafficShapingClick?: () => void;
}) {
  const classes = useStyles();
  const { mdUp } = useBreakpoints();
  const {
    areAllSelectedOnCurrentPage,
    checkAllDisabled,
    onChangeSort,
    reloadAITrafficShapingItems,
    searchKeyword,
    setSearchKeyword,
    sortOptions,
    sortedBy,
    toggleAllOnCurrentPage,
  } = useTrafficShapingFilter();

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        {mdUp && (
          <div className={classes.check}>
            <div>
              <Checkbox
                color="primary"
                checked={areAllSelectedOnCurrentPage}
                onChangeValue={toggleAllOnCurrentPage}
                disabled={checkAllDisabled}
              />
            </div>
          </div>
        )}

        <div className={classes.search}>
          <SearchField
            value={searchKeyword}
            placeholder="Search"
            onChangeValue={setSearchKeyword}
            className={classes.searchField}
          />
        </div>
      </div>
      <div className={classes.bottom}>
        <div className={classes.sort}>
          {mdUp && (
            <IconButton
              onClick={() => {
                reloadAITrafficShapingItems();
              }}
              size="large"
            >
              <Refresh />
            </IconButton>
          )}
          <SelectField
            options={sortOptions}
            value={sortedBy}
            onChange={onChangeSort}
            aria-label="Sort"
            fullWidth={!mdUp}
          />
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AutoAwesome />}
            onClick={onAITrafficShapingClick}
            className={classes.mergeButton}
          >
            Activate AI Traffic Control
          </Button>
        </div>
      </div>
    </div>
  );
}

export default TrafficShapingFilter;
